"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconArchive = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M23.66 41.8h22.68a2 2 0 0 0 2-2v-7.3a2 2 0 0 0-2-2H23.66a2 2 0 0 0-2 2v7.3a2 2 0 0 0 2 2zm2-7.3h18.68v3.3H25.66z"
  }), _react["default"].createElement("path", {
    d: "M63.23 14.9v-.11a2 2 0 0 0-.21-.46 2 2 0 0 0-.37-.4l-7-5.64a2 2 0 0 0-1.26-.44H15.68a2 2 0 0 0-1.26.44l-7 5.64a2 2 0 0 0-.37.4 2 2 0 0 0-.21.46v.11a2 2 0 0 0-.07.5V25a2 2 0 0 0 2 2h3v33.2a2 2 0 0 0 2 2h42.56a2 2 0 0 0 2-2V27h3a2 2 0 0 0 2-2v-9.61a2 2 0 0 0-.1-.49zm-46.84-3.15h37.22l2 1.64H14.36zm37.94 46.5H15.67V27h38.66zm5-35.2H10.7v-5.66h48.6z"
  })),
  height: undefined,
  width: undefined
});
IconArchive.displayName = 'IconArchive';
var _default = IconArchive;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/archive.js
// module id = 548
// module chunks = 0